import React, { useEffect, useRef } from "react";
import * as S from "../../../Common/styles";
export const SLIITALEList = (props) => {
    const textboxRef = useRef(null);

    useEffect(() => {
      if (props.selected === "Other A Level (please specify)") {
        // Focus on the textbox when the "Other" option is selected
        textboxRef.current.focus();
      }
    }, [props.selected]);

    return (
        <S.RadioGroup>
            <label>
                <input className="form-check-input" type="radio" name={props.name} value="Cambridge GCE A Level" onChange={props.onChange} checked={props.selected.includes("Cambridge GCE A Level")}/>
                Cambridge GCE A Level
            </label>
            <label>
                <input className="form-check-input" type="radio" name={props.name} value="Pearson Edexcel A Level" onChange={props.onChange} checked={props.selected.includes("Pearson Edexcel A Level")}/>
                Pearson Edexcel A Level
            </label>
            <label>
                <input className="form-check-input" type="radio" name={props.name} value="Sri Lanka GCE A Level" onChange={props.onChange} checked={props.selected.includes("Sri Lanka GCE A Level")}/>
                Sri Lanka GCE A Level                
            </label>
            <label>
                <input className="form-check-input" type="radio" name={props.name} value="Other A Level (please specify)" onChange={props.onChange} checked={props.selected.includes("Other A Level (please specify)")}/>
                Other A Level (please specify)             
            </label>
            <S.Textbox name= "sliitALEALevelOther" ref={textboxRef} value={props.sliitALEALevelOther} disabled={props.selected !== "Other A Level (please specify)"} onChange={props.onChange} />
        </S.RadioGroup>
    );
}